// @ts-nocheck
import React, { useEffect, useState } from "react";
import InputSelect from "./InputSelect.jsx";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { IMaskInput } from "react-imask";
import { useStores } from "hooks/useStores.js";
import {INVALIDATION_TIP, REGEX} from "../const/validation";

const schema = yup.object().shape({
  name: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(
      REGEX.VALID_NAME,
      INVALIDATION_TIP.INCORRECT_NAME,
    )
    .min(2, INVALIDATION_TIP.MIN_LENGTH_NAME),
  phone: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{10}/, INVALIDATION_TIP.INCORRECT_PHONE),
});

export const FormCallback = () => {
  const [time, setTime] = useState([]);
  const [days, setDays] = useState([]);
  const [daysReady, setDaysReady] = useState(false);
  const [isLoadedFeedback, setIsLoadedFeedback] = useState(false);
  const [urgent, setUrgent] = useState(true);
  const [dayOfCall, setDayOfCall] = useState(1);
  const [timeOfCall, setTimeOfCall] = useState(11);
  const [agreement, setAgreement] = useState("");

  const { api, modalStore } = useStores();

  useEffect(() => {
    api.content.getPageApi("glavnaya")
    .then((res) => {
      setAgreement(res.init_state.agreement);
    });
  }, []);

  useEffect(() => {
      api.content.getFeedbacks()
      .then((response) => {
        setTime(response.time);
        setDays(response.day);
        setIsLoadedFeedback(true);
      })
      .catch((error) => {
        if (error.response.status === 500) {
          throw new Error();
        }
      });
  }, []);
  //--------------------------

  // установка дат и правильного порядка дней недели
  useEffect(() => {
    if (isLoadedFeedback) {
      let date = new Date();
      switch (date.getDay()) {
        case 1:
          days[0].label = "Сегодня";
          days[1].label = "Завтра";
          break;
        case 2:
          days[1].label = "Сегодня";
          days[2].label = "Завтра";
          days.push(days.shift());
          break;
        case 3:
          days[2].label = "Сегодня";
          days[3].label = "Завтра";
          days.push(days.shift());
          days.push(days.shift());
          break;
        case 4:
          days[3].label = "Сегодня";
          days[4].label = "Завтра";
          days.push(days.shift());
          days.push(days.shift());
          days.push(days.shift());
          break;
        case 5:
          days[4].label = "Сегодня";
          days.push(days.shift());
          days.push(days.shift());
          days.push(days.shift());
          days.push(days.shift());
          break;

        // проверка на выходной день
        case 0:
          days[0].label = "Завтра";
          break;
        case 6:
          break;
        default:
          break;
      }
      setDaysReady(true);
    }
  }, [isLoadedFeedback]);
  //--------------------------

  // хэндлеры для переключения табов
  const changeTabAsap = () => {
    document.querySelector(".tabs-asap").classList.add("tabs-active");
    document.querySelector(".tabs-setTime").classList.remove("tabs-active");
    document.querySelector(".form-when-inputs").style.display = "none";
    setUrgent(true);
  };
  const changeTabSetTime = () => {
    document.querySelector(".tabs-asap").classList.remove("tabs-active");
    document.querySelector(".tabs-setTime").classList.add("tabs-active");
    document.querySelector(".form-when-inputs").style.display = "flex";
    setUrgent(false);
  };
  //--------------------------

  // хэндлеры дня и времени
  const dayHandler = (value) => {
    setDayOfCall(value.value);
  };
  const timeHandler = (value) => {
    setTimeOfCall(value.value);
  };
  //--------------------------

  // форма
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    api.content.postFeedback({
      full_name: data.name,
      phone_number: data.phone,
      is_urgent: urgent,
      day_of_call: dayOfCall,
      time_of_call: timeOfCall,
    })
    .then((response) => {
      if (response && response.id) {
        if (typeof window.ym !== 'undefined') {
          window.ym(89149994, 'reachGoal', 'click_zakazatzvonok');
        }
      }
    });
    
    document.querySelector(".form-main").style.display = "none";
    document.querySelector(".form-bubble").style.display = "flex";
  };

  //--------------------------

  // раздача ивент слушателей для работы попапа
  useEffect(() => {
    const calbackButtons = document.querySelectorAll("#callback");
    for (let btn of calbackButtons) {
      btn.addEventListener("click", callbackModal);
    }

    const closeButtons = document.querySelectorAll(".form-close");
    for (let btn of closeButtons) {
      btn.addEventListener("click", callbackModalClose);
    }

    document
      .querySelector("#callbackModalLadnenko")
      .addEventListener("click", callbackModalLadnenko);
  }, []);

  const callbackModal = function () {
    const form = document.querySelector(".form");
    form.style.display = "flex";
    const formMain = document.querySelector(".form-main");
    formMain.style.display = "flex";
    const formBubble = document.querySelector(".form-bubble");
    formBubble.style.display = "none";
  };

  const callbackModalClose = function () {
    modalStore.close()
  };

  const callbackModalLadnenko = function () {
    modalStore.close()
  };

  return (
    <>
      <div className='form-main'>
        <div className='form-title'>форма заказа звонка</div>
        <h1 className='form-subtitle'>«Пак Пакыч» на связи</h1>
        <div className='form-title-description'>
          Заполните необходимые данные и наш менеджер <br /> Вам перезвонит в
          ближайшее время
        </div>
        <form className='form-main-content' onSubmit={handleSubmit(onSubmit)}>
          <div>
            <div className='form-input-name'>
              <label htmlFor='name'>
                Имя <span className='form-input__span'>*</span>
              </label>
              <div>
                <input
                  autoFocus
                  {...register("name")}
                  id='name'
                  name='name'
                  type='text'
                  className='form-input'
                  maxLength='50'
                />

                <p className='cart-form__err'>{errors.name?.message}</p>
              </div>
            </div>

            <div className='form-input-tel'>
              <label htmlFor='phone'>
                Телефон <span className='form-input__span'>*</span>
              </label>
              <Controller
                render={({ field: { onChange, value } }) => (
                  <IMaskInput
                    className='form-input'
                    mask={"+{7} 000 000-00-00"}
                    unmask={true}
                    value={value}
                    placeholder='+7 (___)'
                    onAccept={(val) => onChange(val)}
                  />
                )}
                id='phone'
                name='phone'
                type='tel'
                control={control}
              />
              <p className='cart-form__err'>{errors.phone?.message}</p>
            </div>
            <div className='form-when-title'>Когда вам позвонить?</div>
            <div className='form-when-tabs'>
              <div onClick={changeTabAsap} className='tabs-asap tabs-active'>
                Как можно скорее
              </div>
              <div onClick={changeTabSetTime} className='tabs-setTime'>
                Указать время
              </div>
            </div>
            <div className='form-when-inputs'>
              <div className='when-input-day'>
                {daysReady ? (
                  <InputSelect
                    defaultValue={days[0]}
                    options={days}
                    onchangeInput={dayHandler}
                    selectForm={true}
                  />
                ) : null}
              </div>
              <div className='when-input-time'>
                {isLoadedFeedback ? (
                  <InputSelect
                    defaultValue={time[0]}
                    options={time}
                    onchangeInput={timeHandler}
                    selectForm={true}
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className='form-border'></div>
          <div className='form-personal'>
            <div className='form-personal-text'>
              Отправляя форму соглашаюсь на обработку &nbsp;
              <span>
                <a href={agreement} target='_blank' rel="noreferrer">
                  персональных данных
                </a>
              </span>
            </div>
            <button
              className='form-success-button'
              id='callbackModalSendButton'
              type='submit'
            >
              Отправить
            </button>
          </div>
        </form>
      </div>
      <div className='form-bubble'>
        <button
          type='button'
          onClick={() => {
            reset({
              name: "",
              phone: "",
            });
          }}
          className='form-close'
        ></button>
        <div className='form-bubble-content'>
          <h2 className='form-bubble__title'>
            Форма отправлена. <br /> В ближайшее время мы <br /> свяжемся с
            Вами!
          </h2>
          <button
            className='form-success-button form-button-end'
            id='callbackModalLadnenko'
            onClick={() => {
              reset({
                name: "",
                phone: "",
              });
            }}
          >
            Ладненько
          </button>
        </div>
      </div>
    </>
  );
}
